import { useEffect } from 'react';

const STYLE_ID = 'vantage-cta-sheen-v2';

const CTA_SHEEN_CSS = `
/* Filled secondary CTA — light streak sweep on hover (matches header nav-cta-btn pattern).
   Override --vantage-cta-sheen-accent / --vantage-cta-sheen-on-accent on a parent
   when luminance-picking a fallback accent (e.g. interior card CTAs). */
.vantage-cta-sheen {
  /* !important on the accent vars so an inherited parent-theme stylesheet
     (which still defaults these to primary) cannot win the cascade after
     this sheet is injected and flip filled CTAs back to primary. */
  --_cta-sheen-accent: var(--vantage-cta-sheen-accent, var(--vibe-color-secondary)) !important;
  --_cta-sheen-on-accent: var(--vantage-cta-sheen-on-accent, var(--vibe-color-text-on-secondary)) !important;
  position: relative;
  overflow: hidden;
  background: var(--_cta-sheen-accent) !important;
  border: 1.5px solid var(--_cta-sheen-accent) !important;
  border-radius: 2px;
  color: var(--_cta-sheen-on-accent) !important;
  text-decoration: none;
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease,
              transform 0.3s ease, box-shadow 0.3s ease;
}
.vantage-cta-sheen::before {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-120%);
  background: linear-gradient(
    105deg,
    transparent 0%,
    transparent 35%,
    rgba(255, 255, 255, 0.22) 45%,
    rgba(255, 255, 255, 0.42) 50%,
    rgba(255, 255, 255, 0.22) 55%,
    transparent 65%,
    transparent 100%
  );
  transition: transform 0.6s ease;
  pointer-events: none;
}
.vantage-cta-sheen:hover {
  background-color: color-mix(in srgb, var(--_cta-sheen-accent), black 14%);
  border-color: color-mix(in srgb, var(--_cta-sheen-accent), black 14%);
  color: var(--_cta-sheen-on-accent);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px color-mix(in srgb, var(--_cta-sheen-accent) 35%, transparent);
}
.vantage-cta-sheen:hover::before {
  transform: translateX(120%);
}
.vantage-cta-sheen:active {
  transform: translateY(0);
  box-shadow: none;
}

@media (prefers-reduced-motion: reduce) {
  .vantage-cta-sheen::before {
    display: none;
  }
  .vantage-cta-sheen:hover {
    transform: none;
  }
}
`;

/**
 * Injects the filled CTA sheen-hover CSS into <head> exactly once.
 * Pair with `vantage-cta-sheen` on the anchor and a `relative z-10` label span.
 */
export function useCtaSheenStyles(): void {
  useEffect(() => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CTA_SHEEN_CSS;
    document.head.appendChild(style);
  }, []);
}
